import { render, staticRenderFns } from "./WorkspaceManager.vue?vue&type=template&id=56689a83&"
import script from "./WorkspaceManager.vue?vue&type=script&lang=js&"
export * from "./WorkspaceManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports